import logger from 'src/utils/logger/logger';
export default function detection(agent) {
  let comp_agent = false;
  if (agent.indexOf('stbcoship9108') == -1) {
    comp_agent = agent.indexOf('stbcoship') != -1;
    if (comp_agent) {
      logger.info('[stbcoship detection] detected');
    }
  }
  return comp_agent;
}



// WEBPACK FOOTER //
// ./src/devices/stbcoship/detection.js